<template>
  <div class="flex-1 text-red-500 absolute left-32" style="top: 18px;">
    注：航班/车次信息及时间不清楚时请在票号/航班号处填写待定，时间选择00:00
  </div>
  <div class="info-box">
    <el-form
      v-if="state.model.meetingTransportTicketList?.length > 0"
      :model="state.model"
      label-width="auto"
      label-position="top"
      :show-message="false"
      :inline-message="true"
      ref="formDom"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-card
        v-for="(item, index) in state.model.meetingTransportTicketList"
        :key="item"
        shadow="hover"
        class="mb-3"
        :style="{
          'border-left': item.status
            ? '3px solid ' +
              $base.Meeting_Transport_Ticket_Status?.find(
                (w) => w.Key == item.status,
              )?.BgColor
            : '',
        }"
      >
        <div class="flex flex-col gap-y-4">
          <ul class="flex gap-x-5 items-center flex-wrap gap-y-2">
            <el-form-item
              :prop="'meetingTransportTicketList.' + index + '.trip_type'"
              :rules="[
                { required: true, message: '请选择行程', trigger: 'blur' },
              ]"
              class="!mb-0 flex-1"
            >
              <el-select
                v-model="item.trip_type"
                class="!w-24"
                placeholder="行程"
                :empty-values="[null, undefined, 0]"
              >
                <el-option
                  v-for="option in $base.Meeting_Transport_Trip_Type"
                  :key="option.Key"
                  :label="option.Text"
                  :value="option.Key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="!mb-0">
              <el-select
                v-model="item.status"
                class="!w-24"
                placeholder="未出票"
                :empty-values="[null, undefined, 0]"
                @change="onStatusChange($event, item)"
              >
                <el-option
                  v-for="option in $base.Meeting_Transport_Ticket_Status.filter(
                    (w) => w.Key != 0,
                  )"
                  :key="option.Key"
                  :label="option.Text"
                  :value="option.Key"
                ></el-option>
              </el-select>
            </el-form-item>
            <!--交通票据状态：0未出票 1已出票 2已改签 3已退票 4已取消-->
            <el-form-item class="!mb-0" v-if="[1].includes(item.status)">
              <el-switch
                v-model="item.is_need_pickup"
                active-text="需接送"
                inactive-text="无需接送"
                inline-prompt
                :active-value="1"
                :inactive-value="0"
                size="large"
              />
            </el-form-item>
            <el-button
              type="danger"
              link
              :disabled="item.status"
              :title="item.status ? '仅未出票和已取消状态下的票据允许删除' : ''"
              @click="onDelete(item, index)"
            >
              <template #icon>
                <el-icon :size="18" class="font-bold">
                  <Delete />
                </el-icon>
              </template>
            </el-button>
          </ul>
          <!-- <ul class="flex gap-x-1 items-center">
            <el-select v-model="item.type" class="!w-32" placeholder="交通方式">
              <el-option
                v-for="option in $base.Meeting_Transport_Ticket_Type"
                :key="option.Key"
                :label="option.Text"
                :value="option.Key"
              ></el-option>
            </el-select>
            <text class="text-xs">&#9679;</text>
            <el-input
              v-model="item.ticket_number"
              placeholder="票号"
              class="!w-32"
            />
            <text class="text-xs">&#9679;</text>
            <el-input
              v-model="item.ticket_number"
              placeholder="舱位"
              class="!w-32"
            />
            <text class="text-xs">&#9679;</text>
            <el-date-picker
              v-model="item.reverse_invoice_date"
              type="date"
              placeholder="日期"
              value-format="YYYY-MM-DD"
            />
          </ul> -->
          <ul class="flex gap-x-5 items-center flex-wrap gap-y-2">
            <el-form-item
              label="交通方式"
              :prop="'meetingTransportTicketList.' + index + '.ticket_type'"
              :rules="[
                {
                  required: item.status,
                  validator: (rule, value, callback) => {
                    if (item.status && !value) {
                      callback(new Error('请选择交通方式'));
                    } else {
                      callback();
                    }
                  },
                  trigger: 'change',
                },
              ]"
              class="!mb-0"
            >
              <el-select
                v-model="item.ticket_type"
                class="!w-32"
                placeholder="交通方式"
                :empty-values="[null, undefined, 0]"
                @change="onJtfsChange(item)"
              >
                <el-option
                  v-for="option in $base.Meeting_Transport_Ticket_Type"
                  :key="option.Key"
                  :label="option.Text"
                  :value="option.Key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="
                item.ticket_type == 1
                  ? '车次号'
                  : item.ticket_type == 2
                  ? '航班号'
                  : '票号'
              "
              :prop="'meetingTransportTicketList.' + index + '.transport_no'"
              :rules="[
                {
                  required: item.status,
                  message: '请输入票号',
                  trigger: 'blur',
                },
              ]"
              class="!mb-0"
            >
              <el-input
                v-model="item.transport_no"
                :placeholder="
                  item.ticket_type == 1
                    ? '车次号'
                    : item.ticket_type == 2
                    ? '航班号'
                    : '票号'
                "
                class="!w-32"
              />
            </el-form-item>
            <el-form-item
              v-if="item.ticket_type == 1"
              label="席别"
              :prop="
                'meetingTransportTicketList.' + index + '.d_train_seat_type_id'
              "
              :rules="[
                {
                  required: item.status,
                  validator: (rule, value, callback) => {
                    if (item.status && !value) {
                      callback(new Error('请选择席别'));
                    } else {
                      callback();
                    }
                  },
                  trigger: 'change',
                },
              ]"
              class="!mb-0"
            >
              <el-select
                v-model="item.d_train_seat_type_id"
                class="!w-32"
                placeholder="席别"
                :empty-values="[null, undefined, 0]"
              >
                <el-option
                  v-for="option in state.xb_data"
                  :key="option.id"
                  :label="option.name"
                  :value="option.id"
                ></el-option>
                <template #footer>
                  <el-button
                    plain
                    class="float-right mb-3"
                    size="small"
                    @click="onLoadXb(true)"
                  >
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item
              v-else-if="item.ticket_type == 2"
              label="舱位"
              :prop="
                'meetingTransportTicketList.' +
                index +
                '.d_airline_seat_type_id'
              "
              :rules="[
                {
                  required: item.status,
                  validator: (rule, value, callback) => {
                    if (item.status && !value) {
                      callback(new Error('请选择舱位'));
                    } else {
                      callback();
                    }
                  },
                  trigger: 'change',
                },
              ]"
              class="!mb-0"
            >
              <el-select
                v-model="item.d_airline_seat_type_id"
                class="!w-32"
                placeholder="舱位"
                :empty-values="[null, undefined, 0]"
              >
                <el-option
                  v-for="option in state.cw_data"
                  :key="option.id"
                  :label="option.name"
                  :value="option.id"
                ></el-option>
                <template #footer>
                  <el-button
                    plain
                    class="float-right mb-3"
                    size="small"
                    @click="onLoadCw(true)"
                  >
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item
              v-else
              label="舱位/席别"
              :prop="'meetingTransportTicketList.' + index + '.seat_type'"
              :rules="[
                {
                  required: item.status,
                  validator: (rule, value, callback) => {
                    if (item.status && !value) {
                      callback(new Error('请选择舱位/席别'));
                    } else {
                      callback();
                    }
                  },
                  trigger: 'change',
                },
              ]"
              class="!mb-0"
            >
              <el-select
                v-model="item.seat_type"
                class="!w-32"
                placeholder="舱位/席别"
              >
              </el-select>
            </el-form-item>
            <el-form-item
              label="日期"
              :prop="'meetingTransportTicketList.' + index + '.travel_date'"
              :rules="[
                {
                  required: item.status,
                  message: '请选择日期',
                  trigger: 'blur',
                },
              ]"
              class="!mb-0"
            >
              <el-date-picker
                v-model="item.travel_date"
                type="date"
                placeholder="日期"
                value-format="YYYY-MM-DD"
                @change="
                  (value) => {
                    if (!item.departure_date) item.c_departure_date = value;
                    if (!item.arrival_date) item.c_arrival_date = value;
                  }
                "
              />
            </el-form-item>
          </ul>
          <ul class="flex gap-x-4">
            <el-form-item
              label="出发时间"
              :prop="
                'meetingTransportTicketList.' + index + '.c_departure_time'
              "
              :rules="[
                {
                  required: item.status,
                  message: '请选择出发时间',
                  trigger: 'blur',
                },
              ]"
              class="!mb-0"
            >
              <div class="flex items-center gap-x-2">
                <el-date-picker
                  v-model="item.c_departure_date"
                  type="date"
                  placeholder="出发日期"
                  value-format="YYYY-MM-DD"
                  class="!w-36"
                  :clearable="false"
                />
                <el-time-picker
                  v-model="item.c_departure_time"
                  placeholder="时间"
                  value-format="HH:mm:ss"
                  format="HH:mm"
                  class="!w-28"
                  :save-on-blur="false"
                />
              </div>
            </el-form-item>
            <el-form-item
              label="出发地点"
              :prop="'meetingTransportTicketList.' + index + '.departure_name'"
              :rules="[
                {
                  required: item.status,
                  message: '请输入出发地点',
                  trigger: 'blur',
                },
              ]"
              class="flex-1 !mb-0"
            >
              <template #label>
                <text>出发地点</text>
                <text
                  class="text-xs ml-2 text-orange-500"
                  v-if="item.trip_type == 2"
                >
                  若下拉框中未找到对应的出发地点，可手动输入站点并回车确认选择
                </text>
              </template>
              <!--来程出发地手填-->
              <el-input
                v-model="item.departure_name"
                placeholder="出发地点"
                v-if="item.trip_type == 1"
              />
              <!--返程出发地选择-->
              <el-select
                v-else
                v-model="item.departure_name"
                filterable
                allow-create
                default-first-option
                placeholder="出发地点"
                :clearable="false"
              >
                <el-option
                  v-for="option in state.jsdd_data"
                  :key="option.name"
                  :label="option.name"
                  :value="option.name"
                ></el-option>
                <template #footer>
                  <el-button
                    plain
                    class="float-right mb-3"
                    size="small"
                    @click="onLoadJsdd()"
                  >
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
          </ul>
          <ul class="flex gap-x-5">
            <el-form-item
              label="到达时间"
              :prop="'meetingTransportTicketList.' + index + '.c_arrival_time'"
              :rules="[
                {
                  required: item.status,
                  message: '请选择到达时间',
                  trigger: 'blur',
                },
              ]"
              class="!mb-0"
            >
              <div class="flex items-center gap-x-2">
                <el-date-picker
                  v-model="item.c_arrival_date"
                  type="date"
                  placeholder="到达日期"
                  value-format="YYYY-MM-DD"
                  class="!w-36"
                  :clearable="false"
                />
                <el-time-picker
                  v-model="item.c_arrival_time"
                  placeholder="时间"
                  value-format="HH:mm:ss"
                  format="HH:mm"
                  class="!w-28"
                  :save-on-blur="false"
                />
              </div>
            </el-form-item>
            <el-form-item
              label="到达地点"
              :prop="'meetingTransportTicketList.' + index + '.arrival_name'"
              :rules="[
                {
                  required: item.status,
                  message: '请选择到达地点',
                  trigger: 'blur',
                },
              ]"
              class="flex-1 !mb-0"
            >
              <template #label>
                <text>到达地点</text>
                <text
                  class="text-xs ml-2 text-orange-500"
                  v-if="item.trip_type == 1"
                >
                  若下拉框中未找到对应的到达站点，可手动输入站点并回车确认选择
                </text>
              </template>
              <!--返程到达地手填-->
              <el-input
                v-model="item.arrival_name"
                placeholder="到达地点"
                v-if="item.trip_type == 2"
              />
              <!--来程到达地选择-->
              <el-select
                v-else
                v-model="item.arrival_name"
                filterable
                allow-create
                default-first-option
                placeholder="到达地点"
                :clearable="false"
              >
                <el-option
                  v-for="option in state.jsdd_data"
                  :key="option.name"
                  :label="option.name"
                  :value="option.name"
                ></el-option>
                <template #footer>
                  <el-button
                    plain
                    class="float-right mb-3"
                    size="small"
                    @click="onLoadJsdd()"
                  >
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
          </ul>
          <ul class="flex flex-wrap gap-y-2 gap-x-3 items-center mt-2">
            <el-form-item
              label="票价"
              label-position="left"
              :prop="'meetingTransportTicketList.' + index + '.ticket_price'"
              :rules="[
                {
                  required: item.status,
                  message: '请输入票价',
                  trigger: 'blur',
                },
              ]"
              class="!mb-0"
            >
              <el-input-number
                v-model="item.ticket_price"
                placeholder="票价"
                class="!w-20"
                @focus="$onFocus"
                @change="onBuildItemTotal(item)"
              />
            </el-form-item>
            <el-form-item label="手续费" label-position="left" class="!mb-0">
              <el-input-number
                v-model="item.service_fee"
                placeholder="手续费"
                class="!w-20"
                @focus="$onFocus"
                @change="onBuildItemTotal(item)"
              />
            </el-form-item>
            <el-form-item label="改签费" label-position="left" class="!mb-0">
              <el-input-number
                v-model="item.change_fee"
                placeholder="改签费"
                class="!w-20"
                @focus="$onFocus"
                @change="onBuildItemTotal(item)"
              />
            </el-form-item>
            <el-form-item label="退票费" label-position="left" class="!mb-0">
              <el-input-number
                v-model="item.refund_fee"
                placeholder="退票费"
                class="!w-20"
                @focus="$onFocus"
                @change="onBuildItemTotal(item)"
              />
            </el-form-item>
            <el-form-item label="损失费" label-position="left" class="!mb-0">
              <el-input-number
                v-model="item.refund_loss_fee"
                placeholder="损失费"
                class="!w-20"
                @focus="$onFocus"
                @change="onBuildItemTotal(item)"
              />
            </el-form-item>
            <li class="flex items-center">
              <strong>合计：</strong>
              <c_money
                :value="item.amount"
                :key="item.amount"
                :prefix="false"
                :size="18"
              />
            </li>
          </ul>
        </div>
      </el-card>
    </el-form>
    <div class="text-center" v-else>
      <el-image :src="require('@/assets/images/nodata.png')" />
    </div>
    <div
      class="px-2.5 grid items-center"
      style="grid-template-columns: auto 1fr auto"
    >
      <el-button icon="plus" plain @click="onAdd" class="!w-20">
        添加行程
      </el-button>
      <c_cell title="金额合计" class="m-auto">
        <c_money
          :value="state.total"
          :key="state.total"
          :prefix="false"
          bold
          :size="18"
        />
      </c_cell>
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  dic_getAirlineSeatType,
  dic_getTrainSeatType,
  dic_getPickupPlace,
} from "@/http/data";
import {
  meeting_service_transport_attendee_search,
  meeting_service_transport_attendee_edit,
} from "@/http/meetingservice";
import { post_response, toDecimal } from "@/utils/funcs";
import { dayjs } from "element-plus";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        del_ids: [], //删除的票据id
        meetingTransportTicketList: [],
      },
    });
    onMounted(() => {
      onLoadJsdd();
      if (props.id) {
        meeting_service_transport_attendee_search(props.id).then((res) => {
          if (res.status == 200) {
            const { info, meetingTransportTicketList } = res.data.data || {};
            state.info = info;
            state.model = {
              del_ids: [],
              meetingTransportTicketList: meetingTransportTicketList.map(
                (m) => {
                  return {
                    handle: "edit",
                    id: m.id,
                    trip_type: m.trip_type,
                    ticket_type: m.ticket_type,
                    transport_no: m.transport_no,
                    d_train_seat_type_id: m.d_train_seat_type_id,
                    d_airline_seat_type_id: m.d_airline_seat_type_id,
                    seat_no: m.seat_no,
                    travel_date: m.travel_date,
                    c_departure_date: m.departure_time
                      ? dayjs(m.departure_time).format("YYYY-MM-DD")
                      : "",
                    c_departure_time: m.departure_time
                      ? dayjs(m.departure_time).format("HH:mm:ss")
                      : "",
                    departure_time: m.departure_time,
                    departure_name: m.departure_name,
                    c_arrival_date: m.arrival_time
                      ? dayjs(m.arrival_time).format("YYYY-MM-DD")
                      : "",
                    c_arrival_time: m.arrival_time
                      ? dayjs(m.arrival_time).format("HH:mm:ss")
                      : "",
                    arrival_time: m.arrival_time,
                    arrival_name: m.arrival_name,
                    ticket_price: m.ticket_price,
                    service_fee: m.service_fee,
                    change_fee: m.change_fee,
                    refund_fee: m.refund_fee,
                    refund_loss_fee: m.refund_loss_fee,
                    amount: m.amount,
                    status: m.status,
                    is_need_pickup: m.is_need_pickup,
                  };
                },
              ),
            };
            onBuildTotal();
          }
        });
      }
    });

    //交通方式选择事件    1火车 2飞机
    const onJtfsChange = (item) => {
      if (item.ticket_type == 1) {
        onLoadXb();
        delete item.d_airline_seat_type_id;
      } else if (item.ticket_type == 2) {
        onLoadCw();
        delete item.d_train_seat_type_id;
      }
    };

    //获取席别
    const onLoadXb = (refresh) => {
      if (state.xb_data?.length > 0 && !refresh) return;
      dic_getTrainSeatType().then((res) => {
        if (res.status == 200) {
          state.xb_data = res.data.data;
        }
      });
    };

    //获取舱位
    const onLoadCw = (refresh) => {
      if (state.cw_data?.length > 0 && !refresh) return;
      dic_getAirlineSeatType().then((res) => {
        if (res.status == 200) {
          state.cw_data = res.data.data;
        }
      });
    };

    //获取接送地点
    const onLoadJsdd = () => {
      dic_getPickupPlace().then((res) => {
        if (res.status == 200) state.jsdd_data = res.data.data;
      });
    };

    //添加行程
    const onAdd = () => {
      if (!state.model.meetingTransportTicketList)
        state.model.meetingTransportTicketList = [];

      state.model.meetingTransportTicketList = [
        {
          handle: "add",
        },
        ...state.model.meetingTransportTicketList,
      ];
    };

    //删除
    const onDelete = (item, index) => {
      if (item.handle == "edit") state.model.del_ids.push(item.id);

      state.model.meetingTransportTicketList.splice(index, 1);
      onBuildTotal();
    };

    //计算行内合计
    const onBuildItemTotal = (item) => {
      item.amount = toDecimal(item.ticket_price)
        .plus(toDecimal(item.service_fee))
        .plus(toDecimal(item.change_fee))
        .plus(toDecimal(item.refund_fee))
        .plus(toDecimal(item.refund_loss_fee));

      onBuildTotal();
    };

    //计算总合计
    const onBuildTotal = (item) => {
      const total = state.model.meetingTransportTicketList.reduce(
        (pre, cur) => {
          return pre.plus(toDecimal(cur.amount));
        },
        toDecimal("0"),
      );
      state.total = total;
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          const data = state.model.meetingTransportTicketList.map((m) => {
            return {
              ...m,
              departure_time:
                m.c_departure_date && m.c_departure_time
                  ? m.c_departure_date + " " + m.c_departure_time
                  : null,
              arrival_time:
                m.c_arrival_date && m.c_arrival_time
                  ? m.c_arrival_date + " " + m.c_arrival_time
                  : null,
            };
          });

          meeting_service_transport_attendee_edit({
            id: props.id,
            add_data: data.filter((w) => w.handle == "add") || [],
            edit_data: data.filter((w) => w.handle == "edit") || [],
            del_id: state.model.del_ids || [],
          }).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("close", true);
              }, 500);
            });
          });
        }
      });
    };

    //票据状态切换至已出票，把需要接送默认置为需接送状态
    const onStatusChange = (val, item) => {
      if (val == 1) {
        item.is_need_pickup = 1;
      } else {
        item.is_need_pickup = 0;
      }
    };

    return {
      state,
      props,
      formDom,
      onAdd,
      onDelete,
      onSubmit,
      onJtfsChange,
      onLoadXb,
      onLoadCw,
      onBuildItemTotal,
      onBuildTotal,
      onLoadJsdd,
      onStatusChange,
    };
  },
};
</script>
<style scoped></style>
